module.exports = __webpack_public_path__ + "static/july-4-5c1a7bf02668e5633bb617f968ef2de2.png";